import Layout from '@/layout'

const receptionRouter = {
  path: '/reception',
  component: Layout,
  redirect: '/reception/arrival_guest',
  name: 'reception',
  meta: {
    title: 'Lễ tân'
  },

  children: [
    {
      path: '/reception/arrival_guest',
      name: 'arrivalGuest',
      component: () => import('@/views/mci/reception/ArrivalGuest.vue'),
      meta: {
        title: 'Khách đến'
      }
    },
    {
      path: '/reception/in_house_guest',
      name: 'inHouseGuest',
      component: () => import('@/views/mci/reception/InHouseGuest.vue'),
      meta: {
        title: 'Khách đang ở'
      }
    },
    {
      path: '/reception/assign_guest_information',
      name: 'assignRoom',
      component: () => import('@/views/mci/reception/AssignRoom.vue'),
      meta: {
        title: 'Gán phòng'
      }
    },
    {
      path: '/404',
      // path: '/reception/birthday',
      name: 'birthday',
      component: () => import('@/views/mci/reception/Birthday.vue'),
      meta: {
        title: 'Sinh nhật'
      }
    },
    {
      path: '/reception/room_status',
      name: 'roomStatusByHskp',
      component: () => import('@/views/mci/reception/RoomStatus.vue'),
      meta: {
        title: 'Trạng thái buồng phòng'
      }
    },
    {
      path: '/reception/current_status',
      name: 'hotelStatus',
      component: () => import('@/views/mci/reception/HotelStatus.vue'),
      meta: {
        title: 'Trạng thái khách sạn'
      }
    },
    {
      path: '/reception/future_availability',
      name: 'roomAvailability',
      component: () => import('@/views/mci/reception/RoomAvailability.vue'),
      meta: {
        title: 'Tình trạng phòng trống'
      }
    },
    {
      path: '/reception/room_map',
      name: 'roomMap',
      component: () => import('@/views/mci/reception/roomMap/index.vue'),
      meta: {
        title: 'Sơ đồ phòng'
      }
    },
    {
      path: '/reception/room_schedule',
      name: 'roomSchedule',
      component: () => import('@/views/mci/reception/RoomSchedulePage.vue'),
      meta: {
        title: 'Kế hoạch đặt phòng'
      }
    },
    {
      path: '/404',
      // path: '/reception/export_pa18',
      name: 'exportPoliceReport',
      component: () => import('@/views/mci/reception/ExportPoliceReport.vue'),
      meta: {
        title: 'Xuất báo cáo công an'
      }
    }
  ]
}

export default receptionRouter
